// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const config = {
  apiKey: "AIzaSyChWm4J2AXRqodOL8IGqtv22aOrBE-ZbsM",
  authDomain: "dotrun-52489.firebaseapp.com",
  projectId: "dotrun-52489",
  storageBucket: "dotrun-52489.appspot.com",
  messagingSenderId: "624174201317",
  appId: "1:624174201317:web:9c3481dc6e42cf395a970c",
  measurementId: "G-5QPRKL5WEL"
};

// Initialize Firebase
export const app = initializeApp(config);
// export const app = firebase.initializeApp(firebaseConfig);
// export const auth = app.auth();
// const analytics = getAnalytics(app);